export default __webpack_public_path__ + "static/media/train_partner_3.b1e219da.png";